import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-features',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div
      class="surface-card p-6 md:p-8 border border-border shadow-sm antialiased select-none"
    >
      <div class="flex items-center gap-3 mb-6 pb-3 border-b border-dashed border-border-subtle">
        <div
          class="w-8 h-8 rounded-xl bg-primary/10 flex items-center justify-center text-primary shadow-sm border border-primary/20"
        >
          <i class="fa-solid fa-gem text-xs"></i>
        </div>
        <div>
          <h4 class="text-[10px] font-black uppercase tracking-widest text-text-muted font-mono">
            المرافق والمواصفات
          </h4>
          <h2 class="text-lg font-black text-text-primary tracking-tight mt-0.5">
            مميزات {{ title }}
          </h2>
        </div>
      </div>

      @if (features && features.length) {
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3.5">
          @for (feature of features; track feature) {
            <div
              class="flex items-center gap-3 p-3 rounded-2xl bg-bg-secondary/40 hover:bg-surface-hover border border-border-subtle transition-all duration-300 group cursor-default hover:border-primary/30"
            >
              <div
                class="w-6 h-6 rounded-lg bg-success/10 border border-success/20 flex items-center justify-center text-success shrink-0 shadow-sm transition-transform group-hover:scale-110"
              >
                <i class="fa-solid fa-circle-check text-[11px]"></i>
              </div>

              <span
                class="text-xs font-semibold text-text-secondary group-hover:text-text-primary transition-all duration-300 group-hover:translate-x-0.5 truncate"
                [title]="feature"
              >
                {{ feature }}
              </span>
            </div>
          }
        </div>
      } @else {
        <div
          class="py-8 flex flex-col items-center justify-center border border-dashed border-border bg-bg-secondary/40 rounded-2xl text-center font-mono px-4"
        >
          <div
            class="w-12 h-12 rounded-2xl bg-surface-elevated flex items-center justify-center text-text-muted mb-4 border border-border-subtle shadow-sm"
          >
            <i class="fa-solid fa-sparkles text-lg"></i>
          </div>
          <h4 class="text-xs font-black text-text-secondary uppercase tracking-wider mb-2">
            لا توجد مميزات
          </h4>
          <p
            class="text-[11px] font-medium text-text-muted max-w-[280px] leading-relaxed normal-case font-sans"
          >
            لم يتم تحديد أي مرافق أساسية أو كماليات لـ
            {{ title | lowercase }} بعد.
          </p>
        </div>
      }
    </div>
  `,
})
export class FeaturesComponent {
  @Input() features: string[] = [];
  @Input() title: string = 'Unit';
}
